export default __webpack_public_path__ + "static/media/Shopkeeper.c58b0dc8.svg";